import { render } from "./TimeExpense.vue?vue&type=template&id=b6a4ec28"
import script from "./TimeExpense.vue?vue&type=script&lang=js"
export * from "./TimeExpense.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__